/** NZ hire dates: display and store as DD/MM/YYYY */

const DD_MM_YYYY = /^(\d{2})\/(\d{2})\/(\d{4})$/

export const DATE_PLACEHOLDER = 'DD/MM/YYYY'

export function isValidDdMmYyyy(value) {
  if (!value || !DD_MM_YYYY.test(value)) return false
  const [, ddStr, mmStr, yyyyStr] = value.match(DD_MM_YYYY)
  const day = Number(ddStr)
  const month = Number(mmStr)
  const year = Number(yyyyStr)
  if (month < 1 || month > 12 || day < 1 || day > 31) return false
  const date = new Date(year, month - 1, day)
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  )
}

export function parseDdMmYyyy(value) {
  if (!isValidDdMmYyyy(value)) return null
  const [, ddStr, mmStr, yyyyStr] = value.match(DD_MM_YYYY)
  return new Date(Number(yyyyStr), Number(mmStr) - 1, Number(ddStr))
}

export function formatDdMmYyyyFromDate(date) {
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = String(date.getFullYear())
  return `${day}/${month}/${year}`
}

/** Digits-only → DD/MM/YYYY while typing */
export function formatDdMmYyyyInput(raw) {
  const digits = String(raw || '')
    .replace(/\D/g, '')
    .slice(0, 8)
  if (digits.length <= 2) return digits
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`
}

/** Calendar day at local midnight. */
export function startOfLocalDay(date = new Date()) {
  const d = new Date(date)
  d.setHours(0, 0, 0, 0)
  return d
}

/** Calendar day tomorrow at local midnight. */
export function startOfTomorrowLocal(date = new Date()) {
  const d = startOfLocalDay(date)
  d.setDate(d.getDate() + 1)
  return d
}

/** True when DD/MM/YYYY is tomorrow or a future calendar day (not today). */
export function isDdMmYyyyOnOrAfterTomorrow(value) {
  const date = parseDdMmYyyy(value)
  if (!date) return false
  return date.getTime() >= startOfTomorrowLocal().getTime()
}

/** True when DD/MM/YYYY is today or a future calendar day. */
export function isDdMmYyyyOnOrAfterToday(value) {
  const date = parseDdMmYyyy(value)
  if (!date) return false
  return date.getTime() >= startOfLocalDay().getTime()
}
